<template>
    <div class="page-wrapper" id="main-wrapper" data-layout="horizontal" data-navbarbg="skin6" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        <div class="position-relative overflow-hidden radial-gradient min-vh-100 d-flex align-items-center justify-content-center">
            <div class="d-flex align-items-center justify-content-center w-100">
                <div class="row justify-content-center w-100">
                    <div class="col-md-8 col-lg-6 col-xxl-3">
                        <div class="card mb-0">
                            <div class="card-body">
                                <router-link :to="{ name: 'Login' }"
                                    class="text-nowrap logo-img text-center d-block mb-5 w-100">
                                    <img :src="app ? app.icon : '@/assets/logo.png'" style="
                                        width: 100%;
                                        height: 100%;
                                    ">
                                </router-link>
                                <form @submit.prevent="onLogin">
                                    <div class="mb-3">
                                        <label class="form-label">Correo Electrónico</label>
                                        <input type="email" class="form-control" name="email" v-model="data.email" :class="{ 'form-control-danger': errors.email }">
                                        <small class="form-control-feedback" v-for="(error, index) in errors.email" :key="index">
                                            {{ error }}
                                        </small>
                                    </div>
                                    <div class="mb-4">
                                        <label class="form-label">Contraseña</label>
                                        <input type="password" class="form-control" name="password" v-model="data.password" :class="{ 'form-control-danger': errors.password }">
                                        <small class="form-control-feedback" v-for="(error, index) in errors.password" :key="index">
                                            {{ error }}
                                        </small>
                                    </div>
                                    <button type="submit" class="btn btn-primary w-100 py-8 mb-4 rounded-2">
                                      <span v-if="count" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span :class="{ 'visually-hidden' : count }">
                                          <i class="ti ti-login me-1 fs-4"></i> Iniciar sesión
                                        </span>
                                      </button>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <router-link :to="{ name: 'Home' }" class="text-primary fw-medium ms-2"
                                            href="">Volver</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'app'
    ])
  },
  data () {
    return {
      data: {
        email: '',
        password: ''
      },
      errors: {},
      count: 0
    }
  },
  methods: {
    onLogin: function () {
      this.count++
      if (this.count !== 1) {
        return
      }
      this.$axios({
        url: '/login',
        method: 'POST',
        data: this.data
      })
        .then((resp) => {
          this.$store.dispatch('LOGIN', resp.data)
          this.$router.push({ name: 'Calendar' })
        })
        .catch((err) => {
          if (err.response.status !== 422) {
            let message = err.response ? err.response.data.message : err.message
            this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          } else {
            this.errors = err.response.data
          }
        })
        .finally((resp) => {
          this.count = 0
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/Login.vue